import { c as _c } from "react/compiler-runtime";
import { Icons } from '../../icons';
import { colors } from '../../styles/colors';
import { ButtonProps, Button } from './Button';
export const Cancel: React.FC<ButtonProps> = t0 => {
  const $ = _c(4);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icons.Cancel />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = text || "Cancel";
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundColor: colors.surface.default,
      color: colors.text.default
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <Button startIcon={t1} text={t2} sx={t3} />;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};